import IconButton from "../features/common/IconButton";
import { useDispatch, useSelector } from "react-redux";
import { setOpenModal } from "../../store/interviewConfigReducer";
import MixMatchComponents from "./mixMatch/MixMatchComponents";
import "./Style.css";

const InterviewConfigHeader = () => {
  const dispatch = useDispatch();
  const { openModal } = useSelector((state) => state.interviewconfig);

  const handleOpenModal = () => {
    dispatch(setOpenModal(true));
  };

  return (
    <>
      <div className="interview-config-header">
        <div className="interview-config-header-title-section">
          <h1 className="interview-config-header-title">
            Interview Configuration
          </h1>
          <p className="interview-config-header-subtitle">
            Manage interview types, difficulty levels, and interviewer profiles
          </p>
        </div>
        <div className="interview-config-header-actions">
          <IconButton
            label="Mix & Match Builder"
            icon="shuffle"
            color="blue-600"
            hoverColor="blue-700"
            onClick={() => handleOpenModal()}
          />
        </div>
      </div>
      {openModal && <MixMatchComponents  />}
    </>
  );
};
export default InterviewConfigHeader;
